import { render, staticRenderFns } from "./ProjectCopy.vue?vue&type=template&id=06e97148&scoped=true&"
import script from "./ProjectCopy.vue?vue&type=script&lang=js&"
export * from "./ProjectCopy.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCopy.vue?vue&type=style&index=0&id=06e97148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e97148",
  null
  
)

export default component.exports